export type PromiseAbortSignal = {
  aborted: boolean;
};

/**
 * Used together with promises to keep track of aborted state.
 */
export class PromiseAbortController {
  readonly signal: PromiseAbortSignal = { aborted: false };
  abort() {
    this.signal.aborted = true;
  }
  reset() {
    this.signal.aborted = false;
  }
}
